/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
author: abdullahyeahyea (https://sketchfab.com/abdullahyeahyea)
license: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
source: https://sketchfab.com/3d-models/low-poly-gaming-desk-6f1bc394de704e488d44e77134f23993
title: Low Poly Gaming Desk
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export default function Desk({ ...props }) {
  const group = useRef()
  const { nodes, materials } = useGLTF('/desk.gltf')
  return (
    <group ref={group} {...props} dispose={null}>
      <group rotation={[-Math.PI / 2, 0, 0]} scale={1} position={[0,0,-0.2]} >
        <group rotation={[Math.PI / 2, 0, 0]}>
          <group position={[-1.15, -2.84, -1.51]} scale={[1, 1, 0.88]}>
            <mesh geometry={nodes.Object_4.geometry} material={materials['Material.003']} />
            <mesh geometry={nodes.Object_5.geometry} material={nodes.Object_5.material} />
          </group>
          <group position={[-0.91, 0.55, -2.3]} scale={[0.52, 0.1, 0.34]}>
            <mesh geometry={nodes.Object_8.geometry} material={nodes.Object_8.material} />
            <mesh geometry={nodes.Object_9.geometry} material={nodes.Object_9.material} />
          </group>
          <group position={[-0.9, 0.47, -0.43]} rotation={[0, 0, -Math.PI]} scale={[-1.41, 0.02, 0.42]}>
            <mesh geometry={nodes.Object_11.geometry} material={nodes.Object_11.material} />
            <mesh geometry={nodes.Object_12.geometry} material={nodes.Object_12.material} />
          </group>
          <group position={[0.79, 0.47, -0.78]} scale={[0.11, 0.11, 0.2]}>
            <mesh geometry={nodes.Object_14.geometry} material={nodes.Object_14.material} />
            <mesh geometry={nodes.Object_15.geometry} material={nodes.Object_15.material} />
          </group>
          <group position={[-2.7, -1.5, -1.59]} scale={[0.44, 1, 1.09]}>
            <mesh geometry={nodes.Object_17.geometry} material={nodes.Object_17.material} />
            <mesh geometry={nodes.Object_18.geometry} material={nodes.Object_18.material} />
            <mesh geometry={nodes.Object_19.geometry} material={nodes.Object_19.material} />
          </group>

          <group position={[0.71, 0.47, -0.75]} scale={0.58}>
            <mesh geometry={nodes.Object_24.geometry} material={nodes.Object_24.material} />
            <mesh geometry={nodes.Object_25.geometry} material={nodes.Object_25.material} />
          </group>
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/scene.gltf')
